// @flow

import React, { ReactNode } from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

type Size = 'normal';
type Props = {
  isLoading: boolean,
  length?: number,
  isNoDataContainerVisible?: boolean,
  noDataContainer?: string | ReactNode,
  className?: string,
  size?: Size,
  children: React$Node,
};

const Preloader = ({
  isLoading,
  length = 1,
  isNoDataContainerVisible = true,
  noDataContainer = 'Ничего не найдено',
  children,
  className,
  size = 'normal',
}: Props) => (
  <>
    {isLoading
      ? (
        <div
          className={cx(
            styles.preloader,
            className,
            styles[size],
          )}
        >
          <span />
          <span />
          <span />
        </div>
      )
      : (
        <>
          {isNoDataContainerVisible && !length
            ? (
              <div className={styles.noDataFound}>
                {noDataContainer}
              </div>
            ) : children}
        </>
      )}
  </>
);

export default Preloader;
